import React, { useState } from 'react'
import { DashboardData, GranteeDto, OrganizationData } from '../types'
import { ClipLoader } from 'react-spinners'
import { formatPrice } from '../utils'

interface DashBoardStateProps {
  stats: DashboardData
  isApiRequestInProgress: any
}

type DashBoardProps = DashBoardStateProps
const TopGrantees = ({ stats, isApiRequestInProgress }: DashBoardProps): JSX.Element => {
  return (
    <div
      id="projectSummary"
      data-list='{"valueNames":["firstName","lastName", "email", "workCount", "grantAmount"],"page":6,"pagination":true}'
    >
      <div className="row align-items-end justify-content-between pb-4 g-3">
        <div className="col-auto">
          <h3>Top 5 grantees</h3>
          <p>by number of works created</p>
        </div>
      </div>

      {isApiRequestInProgress ? (
        <div className="spinner-wrapper mb-5">
          <ClipLoader color="#e5780b" loading={isApiRequestInProgress} size={35} />
        </div>
      ) : (
        <div className="table-responsive ms-n1 ps-1 scrollbar mb-4">
          {stats.topGrantees.length ? (
            <table className="table fs--1 mb-0 border-top border-200">
              <thead>
                <tr>
                  <th className="sort align-middle ps-3" scope="col" data-sort="firstName" style={{ width: '10%' }}>
                    First Name
                  </th>
                  <th className="sort align-middle ps-3" scope="col" data-sort="lastName" style={{ width: '10%' }}>
                    Last Name
                  </th>
                  <th className="sort align-middle ps-3" scope="col" data-sort="email" style={{ width: '10%' }}>
                    Email
                  </th>
                  <th className="sort align-middle ps-3" scope="col" data-sort="workCount" style={{ width: '10%' }}>
                    Work Count
                  </th>
                  <th className="sort align-middle ps-3" scope="col" data-sort="grantAward" style={{ width: '10%' }}>
                    Money Award
                  </th>
                </tr>
              </thead>
              <tbody className="list" id="project-summary-table-body">
                {stats.topGrantees.map((grantee: GranteeDto) => (
                  <tr key={grantee.email} className="position-static">
                    <td className="align-middle time fs--1 white-space-nowrap ps-3 firstName">
                      <p className="mb-0 fs--1 text-900">{grantee.firstName}</p>
                    </td>
                    <td className="align-middle white-space-nowrap ps-3 lastName">
                      <p className="mb-0 fs--1 text-900">{grantee.lastName}</p>
                    </td>
                    <td className="align-middle white-space-nowrap ps-3 email">
                      <p className="mb-0 fs--1 text-900">{grantee.email}</p>
                    </td>
                    <td className="align-middle white-space-nowrap ps-3 workCount">
                      <p className="mb-0 fs--1 text-900">{grantee.workAmount}</p>
                    </td>
                    <td className="align-middle white-space-nowrap ps-3 grantAward">
                      <p className="mb-0 fs--1 text-900">${formatPrice(grantee.moneyAwarded)}</p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="my-7 text-center">No Grantees found</div>
          )}
        </div>
      )}
    </div>
  )
}

export default TopGrantees
